import { Flex, FormTextField } from '@shared/components';

const AUDIT_COUNT = 3;

export default function OwnerFormSection() {
  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <FormTextField name='owners.owner' label='ผู้พัฒนาข้อสอบ' placeholder='กรุณาระบุชื่อ' />
      {[...Array.from({ length: AUDIT_COUNT }).keys()].map((value) => (
        <FormTextField
          key={`owner-form-text-field-${value}`}
          name={`owners.audit${value + 1}`}
          label={`ผู้ทบทวนข้อสอบ ${value + 1}`}
          placeholder='กรุณาระบุชื่อ'
        />
      ))}
    </Flex>
  );
}
